// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TextField } from '@material-ui/core';

import Button from '../Button';

/** @type { { key: string, label?: string, scaled?: boolean }[] } */
const KEYPAD_ITEMS = [
  { key: '1' },
  { key: '2', label: 'ABC' },
  { key: '3', label: 'DEF' },
  { key: '4', label: 'GHI' },
  { key: '5', label: 'JKL' },
  { key: '6', label: 'MNO' },
  { key: '7', label: 'PQRS' },
  { key: '8', label: 'TUV' },
  { key: '9', label: 'WXYZ' },
  { key: '*', scaled: true },
  { key: '0', label: '+' },
  { key: '#' },
];

const Keypad = ({ classes, onKeySelect, controls, buttonStyles, value, textFieldProps, readOnly }) => {
  /**
   * @param {boolean} [scaled]
   * @returns {{ root: string, label: string }}
   */
  const getKeyBtnClasses = (scaled) => {
    const root = cx(classes.roundBtn, classes.keyBtn, buttonStyles);
    const label = cx(classes.btnLabel, scaled && classes.btnLabelCentered);

    return { root, label };
  };

  return (
    <div className={classes.content}>
      <TextField
        type="text"
        data-testid="keypad-input"
        fullWidth
        autoFocus
        InputProps={{
          classes: {
            root: classes.textField,
            input: classes.input,
          },
          readOnly,
          disableUnderline: true,
        }}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{ inputMode: 'none' }}
        value={value}
        {...textFieldProps}
      />
      <div className={classes.keysContainer}>
        {KEYPAD_ITEMS.map(({ key, label, scaled }) => (
          <Button
            classes={getKeyBtnClasses(scaled)}
            onClick={() => onKeySelect(key)}
            key={key}
            data-testid={`btn-key-${key}`}
          >
            <span className={cx(classes.keyTitle, scaled && classes.keyTitleScaled)}>{key}</span>
            <span className={classes.keyLabel}>{label}</span>
          </Button>
        ))}
        {controls}
      </div>
    </div>
  );
};

Keypad.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.string.isRequired,
  onKeySelect: PropTypes.func.isRequired,
  controls: PropTypes.element,
  buttonStyles: PropTypes.string,
  readOnly: PropTypes.bool,
  textFieldProps: PropTypes.shape({
    onClick: PropTypes.func,
    onCopy: PropTypes.func,
    onPaste: PropTypes.func,
  }),
};

Keypad.defaultProps = {
  classes: {},
  controls: null,
  readOnly: true,
  textFieldProps: {},
};

export default Keypad;
